import { Suspense, lazy } from 'react';

import { Skeleton } from '@spotify/confidence-core-react';
import { createCodeBlockExtension } from '@spotify/plugin-confidence-chat-react';

import { issuesPlugin } from '../../plugin';
import { hasEvidenceFindings } from './parseEvidenceBlock';

const EVIDENCE_CODE_BLOCK_LANGUAGE = 'evidence';

const EvidenceBlockView = lazy(() =>
  import('./EvidenceBlockView').then(module => ({
    default: module.EvidenceBlockView,
  })),
);

export const EvidenceCodeBlockExtension = issuesPlugin.provide(
  createCodeBlockExtension({
    id: 'evidence-code-block',
    predicate: ({ language, content }) =>
      language === EVIDENCE_CODE_BLOCK_LANGUAGE && hasEvidenceFindings(content),
    render: ({ content }) => (
      <Suspense
        fallback={<Skeleton variant="rect" width="100%" height={160} />}
      >
        <EvidenceBlockView content={content} />
      </Suspense>
    ),
  }),
);
